import { skipToken } from '@apollo/client';
import { composeFilter, Filter, FilterConfig } from 'src/utils/composeFilter.ts';
import { UserSettings } from 'src/types/UserSettings.ts';
import { ActuatorAccessoriesPageVariables } from 'src/actuators/accessories/ActuatorAccessoriesPageMapping.ts';

export const buildCheckoutVariables = ({
    mandatoryFilterConfig,
    filter,
    actuatorLabel,
    userSettings,
}: {
    mandatoryFilterConfig: { config: FilterConfig; values: Filter };
    filter: Filter;
    actuatorLabel: string;
    userSettings: UserSettings;
}): { variables: ActuatorAccessoriesPageVariables } | typeof skipToken => {
    if (filter === null) {
        return skipToken;
    }
    return {
        variables: {
            filter: composeFilter(
                mandatoryFilterConfig.config,
                mandatoryFilterConfig.values,
                userSettings.currentLocale,
            ),
            label: actuatorLabel,
            locale: userSettings.currentLocale,
        },
    };
};
